export const LogoHelperLong: {
  name: 'logo_helper_long-e0f97f304aac'
} = {
  name: 'logo_helper_long-e0f97f304aac'
}
